const DEFAULT_FONT_FAMILY = "DM Sans";
var FontSize = /* @__PURE__ */ ((FontSize2) => {
  FontSize2["xs"] = "0.75rem";
  FontSize2["sm"] = "0.875rem";
  FontSize2["normal"] = "1rem";
  FontSize2["lg"] = "1.25rem";
  FontSize2["xl"] = "1.5rem";
  FontSize2["2xl"] = "2.125rem";
  FontSize2["3xl"] = "3rem";
  FontSize2["4xl"] = "3.75rem";
  FontSize2["5xl"] = "6rem";
  return FontSize2;
})(FontSize || {});
var FontWeight = /* @__PURE__ */ ((FontWeight2) => {
  FontWeight2[FontWeight2["normal"] = 400] = "normal";
  FontWeight2[FontWeight2["medium"] = 500] = "medium";
  FontWeight2[FontWeight2["bold"] = 700] = "bold";
  return FontWeight2;
})(FontWeight || {});
var LineHeight = /* @__PURE__ */ ((LineHeight2) => {
  LineHeight2[LineHeight2["3xs"] = 1.17] = "3xs";
  LineHeight2[LineHeight2["2xs"] = 1.2] = "2xs";
  LineHeight2[LineHeight2["xs"] = 1.24] = "xs";
  LineHeight2[LineHeight2["sm"] = 1.33] = "sm";
  LineHeight2[LineHeight2["md"] = 1.5] = "md";
  LineHeight2[LineHeight2["lg"] = 1.57] = "lg";
  LineHeight2[LineHeight2["xl"] = 1.6] = "xl";
  LineHeight2[LineHeight2["2xl"] = 1.66] = "2xl";
  LineHeight2[LineHeight2["3xl"] = 1.75] = "3xl";
  LineHeight2[LineHeight2["4xl"] = 2.66] = "4xl";
  return LineHeight2;
})(LineHeight || {});
var LetterSpacing = /* @__PURE__ */ ((LetterSpacing2) => {
  LetterSpacing2["tighter"] = "-0.0938rem";
  LetterSpacing2["tight"] = "-0.0313rem";
  LetterSpacing2["normal"] = "0rem";
  LetterSpacing2["wide"] = "0.0011rem";
  LetterSpacing2["wider"] = "0.025rem";
  LetterSpacing2["widerMedium"] = "0.029rem";
  LetterSpacing2["widerPlus"] = "0.0625rem";
  LetterSpacing2["widest"] = "0.0094rem";
  return LetterSpacing2;
})(LetterSpacing || {});
const typography = {
  fontFamily: [DEFAULT_FONT_FAMILY, "Open Sans", "-apple-system", "BlinkMacSystemFont", '"Segoe UI"', "Roboto", '"Helvetica Neue"', "Arial", "sans-serif", '"Apple Color Emoji"', '"Segoe UI Emoji"', '"Segoe UI Symbol"'].join(","),
  allVariants: {
    fontFamily: DEFAULT_FONT_FAMILY
  },
  h1: {
    fontSize: "6rem",
    fontWeight: 500,
    lineHeight: 1.17,
    letterSpacing: "-0.0938rem"
    /* tighter */
  },
  h2: {
    fontSize: "3.75rem",
    fontWeight: 500,
    lineHeight: 1.2,
    letterSpacing: "-0.0313rem"
    /* tight */
  },
  h3: {
    fontSize: "3rem",
    fontWeight: 500,
    lineHeight: 1.17,
    letterSpacing: "0rem"
    /* normal */
  },
  h4: {
    fontSize: "2.125rem",
    fontWeight: 700,
    lineHeight: 1.24,
    letterSpacing: "0rem"
    /* normal */
  },
  h5: {
    fontSize: "1.5rem",
    fontWeight: 700,
    lineHeight: 1.33,
    letterSpacing: "0rem"
    /* normal */
  },
  h6: {
    fontSize: "1.25rem",
    fontWeight: 700,
    lineHeight: 1.6,
    letterSpacing: "0rem"
    /* normal */
  },
  subtitle1: {
    fontSize: "1rem",
    fontWeight: 700,
    lineHeight: 1.75,
    letterSpacing: "0.0094rem"
    /* widest */
  },
  subtitle2: {
    fontSize: "0.875rem",
    fontWeight: 700,
    lineHeight: 1.57,
    letterSpacing: "0.0094rem"
    /* widest */
  },
  body1: {
    fontSize: "1rem",
    fontWeight: 400,
    lineHeight: 1.5,
    letterSpacing: "0.0094rem"
    /* widest */
  },
  body2: {
    fontSize: "0.875rem",
    fontWeight: 400,
    lineHeight: 1.5,
    letterSpacing: "0.0011rem"
    /* wide */
  },
  overline: {
    fontSize: "0.75rem",
    fontWeight: 400,
    lineHeight: 2.66,
    letterSpacing: "0.0625rem"
    /* widerPlus */
  },
  caption: {
    fontSize: "0.75rem",
    fontWeight: 400,
    lineHeight: 1.66,
    letterSpacing: "0.025rem"
    /* wider */
  },
  button: {
    fontWeight: 500,
    textTransform: "none"
  }
};
export {
  DEFAULT_FONT_FAMILY,
  FontSize,
  FontWeight,
  LetterSpacing,
  LineHeight,
  typography
};
//# sourceMappingURL=typography.es.js.map
